import { Helpers } from '../../helpers';
import { ILandArea } from '../../interfaces/iland-area';
import { Area } from '../area';
import { TotalLandDamage } from '../total-land-damage';

export class LandAreaBase {
  LandAreaId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Areas_LandArea?: Array<Area> | null;
  TotalLandDamages_LandArea?: Array<TotalLandDamage> | null;

  constructor(item?: ILandArea) {
    if (item) {

      this.LandAreaId = item.LandAreaId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Areas_LandArea = Helpers.createClassArray(Area, item.Areas_LandArea);
      this.TotalLandDamages_LandArea = Helpers.createClassArray(TotalLandDamage, item.TotalLandDamages_LandArea);
    }
  }
}